import React, { useEffect, useState, lazy } from 'react';
import { ImageCarousel } from '../components/ImageCarousel';
import { FrustrationMethodSection } from '../components/FrustrationMethodSection';
import { AboutAuthorSection } from '../components/AboutAuthorSection';
import { FAQSection } from '../components/FAQSection';
import { useCurrency } from '../components/CurrencyContext';
import { LazySection } from '../components/LazySection';
import { CheckCircle2, StarIcon, XCircle, X, Check } from 'lucide-react';
export function LandingPage() {
  const {
    currency,
    loading,
    formatPrice
  } = useCurrency();
  const [activeSlide, setActiveSlide] = useState(0);
  const bonusImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/gvoSaTXxkxMoKNmgaHbrNJ/Guia_completa_para_sustitucion_de_ingredientes.png',
    title: 'Guía de Sustitución de Ingredientes',
    subtitle: 'Sustituye con éxito y sin renunciar al sabor'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ooQ7xn6Kcd3i9RdH2HHTAX/Recetas_de_pizza_sin_gluten.png',
    title: 'Recetas de Pizza Sin Gluten',
    subtitle: 'Masa perfecta sin gluten'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/7YyMXGsWB5VaeYapxfWrVs/Recetario_sin_gluten__opciones_deliciosas.png',
    title: '50 Almuerzos y Cenas Sin Gluten',
    subtitle: 'Platos deliciosos y sin riesgos'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/ikX66etNbDDmfmXqTRHd4c/Planificador_de_comidas_semanales_con_recetas.png',
    title: 'Planificador de Comidas Semanales',
    subtitle: 'Organiza tus comidas sin gluten'
  }];
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveSlide(prev => (prev + 1) % bonusImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [bonusImages.length]);
  // scrollToOffer removed in favor of CartDrawer
  return <div className="min-h-screen text-gray-900 font-inter selection:bg-orange-200 bg-[#FFFF] overflow-x-hidden" data-id="element-235">
      {/* ANNOUNCEMENT BAR */}
      <div className="sticky top-0 z-50 bg-[#FF8C00] h-[44px] flex items-center overflow-hidden whitespace-nowrap" data-id="element-236">
        <div className="animate-marquee flex items-center gap-0" data-id="element-237">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-238">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
        <div className="animate-marquee2 flex items-center gap-0 absolute" data-id="element-239">
          {[...Array(6)].map((_, i) => <span key={i} className="font-bold text-black text-sm md:text-base tracking-wide px-8" data-id="element-240">
              🔥 RECIBE +10 BONOS GRATIS SOLO POR HOY
            </span>)}
        </div>
      </div>

      {/* PROBLEM & AGITATION SECTION */}
      <LazySection data-id="element-241">
        <section className="py-16 px-4 bg-white/80 pt-[0px] pb-[0px]" data-id="element-242">
          <div className="max-w-2xl mx-auto space-y-[12px]" data-id="element-243">
            <h2 className="md:text-3xl text-center mb-3 text-gray-900 pt-[17px] pb-[0px] text-[20px] font-[800] font-[Inter,_sans-serif]" data-id="element-244">
              Esta misma semana puedes pasar de principiante a experto en
              comandos eléctricos...
            </h2>

            {/* Subheadline highlight box */}
            <div className="mx-auto max-w-md mt-2 mb-4" data-id="element-245">
              <div className="relative bg-[#FFFDE7] border-2 border-[#FFD814] rounded-xl px-5 py-4 shadow-[0_2px_12px_rgba(255,216,20,0.25)]" data-id="element-246">
                <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-[#FFD814] text-black text-[10px] font-black px-3 py-0.5 rounded-full uppercase tracking-wider" data-id="element-247">
                  Importante
                </div>
                <p className="text-center text-[15px] md:text-[17px] font-[700] text-gray-900 leading-snug font-[Poppins,_sans-serif]" data-id="element-248">
                  …y empezar a generar entre $2.000 y $5.000 adicionales al mes
                  con una habilidad que realmente tiene demanda
                </p>
              </div>
            </div>

            {/* iPhone Mockup */}
            <LazySection delay={100} data-id="element-249">
              <div className="flex justify-center mb-4" data-id="element-250">
                <div className="relative mx-auto" style={{
                maxWidth: '280px',
                width: '100%'
              }} data-id="element-251">
                  {/* Phone frame */}
                  <div className="relative bg-black rounded-[40px] p-[10px] shadow-[0_20px_60px_rgba(0,0,0,0.3),_0_0_0_1px_rgba(255,255,255,0.1)]" data-id="element-252">
                    {/* Notch / Dynamic Island */}
                    <div className="absolute top-0 left-1/2 -translate-x-1/2 z-10 bg-black w-[90px] h-[28px] rounded-b-[14px]" data-id="element-253" />
                    {/* Screen */}
                    <div className="relative rounded-[30px] overflow-hidden bg-black" data-id="element-254">
                      <video src="https://cdn.magicpatterns.com/uploads/36vP7fiQ7TLs6MJM7K5NF8/undefined - Imgur.mp4" className="w-full h-auto block" autoPlay loop muted playsInline preload="none" data-id="element-255" />
                    </div>
                    {/* Home indicator */}
                    <div className="absolute bottom-[6px] left-1/2 -translate-x-1/2 w-[100px] h-[4px] bg-gray-600 rounded-full" data-id="element-256" />
                  </div>
                </div>
              </div>

              <div className="text-center mb-8 px-2" data-id="element-257">
                <p className="md:text-lg text-[14px] text-[#0B0A0A] font-[700]" data-id="element-258">
                  Descubre la guía visual paso a paso que más de 12,000 personas
                  ya están usando para empezar desde cero y avanzar sin errores.
                </p>
              </div>
            </LazySection>

            {/* Social Proof Avatars + Rating */}
            <LazySection delay={200} data-id="element-259">
              <div className="flex flex-col items-center mb-6" data-id="element-260">
                {/* Overlapping Avatars */}
                <div className="flex items-center -space-x-3 mb-3" data-id="element-261">
                  {['https://cdn.magicpatterns.com/uploads/aHC77Wj73vWEMuCYB1KkFm/86.jpg', 'https://cdn.magicpatterns.com/uploads/7hamwSg4b4Z5A3vEjRXdt5/11.jpg', 'https://cdn.magicpatterns.com/uploads/1daLw83rpBvzHXEtjvLwva/86_(1).jpg', 'https://cdn.magicpatterns.com/uploads/eJKoJZ6FShTQjMFiS1Ez1E/22.jpg'].map((src, i) => <img key={i} src={src} alt={`Estudiante verificado ${i + 1}`} className="w-12 h-12 md:w-14 md:h-14 rounded-full object-cover border-[3px] border-white shadow-md" loading="lazy" data-id="element-262" />)}
                </div>

                {/* Stars */}
                <div className="flex gap-0.5 mb-1.5" data-id="element-263">
                  {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#4F6BFF] text-[#4F6BFF]" data-id="element-264" />)}
                </div>

                {/* Rating Text */}
                <p className="text-gray-900 font-bold text-sm md:text-base" data-id="element-265">
                  4.9/5 (12,349 Estudiantes Verificados)
                </p>

                {/* Insight Card */}
                <div className="mt-4 bg-[#FFF8E1] border border-[#F0EBE0] rounded-xl px-5 py-4 max-w-md shadow-[0_2px_10px_rgba(0,0,0,0.04)]" data-id="element-266">
                  <p className="text-gray-800 text-[14px] md:text-[15px] font-medium leading-snug text-center" data-id="element-267">
                    ⚡ Muchos electricistas y técnicos pierden oportunidades
                    cada semana por no dominar los comandos eléctricos.
                  </p>
                </div>

                <p className="mt-4 text-center text-[16px] md:text-[18px] font-bold text-gray-900" data-id="element-268">
                  Opinión de quienes lo compraron 👇🏻
                </p>
              </div>

              {/* Video Testimonials */}
              <div className="flex flex-col gap-6 mt-2 mb-8 w-full max-w-md mx-auto px-2" data-id="element-269">
                {/* Video 1 */}
                <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-5 flex flex-col items-center text-center" data-id="element-270">
                  <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-5 bg-black" data-id="element-271">
                    <video src="https://cdn.magicpatterns.com/uploads/9i11Vjyfiyk1yw5VqYEhgN/undefined - Imgur (1).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="auto" data-id="element-272" />
                  </div>
                  <div className="flex gap-1 mb-3" data-id="element-273">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-274" />)}
                  </div>
                  <h4 className="text-[20px] font-bold text-gray-900 mb-1" data-id="element-275">
                    Luis Ramírez
                  </h4>
                  <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-4" data-id="element-276">
                    Técnico Electricista
                  </p>
                  <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-277">
                    "Ahora puedo realizar mis propios proyectos sin depender de
                    nadie y ganar más."
                  </p>
                </div>

                {/* Video 2 */}
                <div className="bg-white rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.06)] border border-gray-100 p-5 flex flex-col items-center text-center" data-id="element-278">
                  <div className="relative w-full aspect-video rounded-xl overflow-hidden mb-5 bg-black" data-id="element-279">
                    <video src="https://cdn.magicpatterns.com/uploads/wnbQ9Bgc4WFeND59VotTcs/undefined - Imgur (2).mp4#t=0.5" className="w-full h-full object-cover" controls playsInline preload="auto" data-id="element-280" />
                  </div>
                  <div className="flex gap-1 mb-3" data-id="element-281">
                    {Array.from({
                    length: 5
                  }).map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" data-id="element-282" />)}
                  </div>
                  <h4 className="text-[20px] font-bold text-gray-900 mb-1" data-id="element-283">
                    Francisco Javier
                  </h4>
                  <p className="text-[#2563EB] font-bold text-[13px] uppercase tracking-wide mb-4" data-id="element-284">
                    Electricista Independiente
                  </p>
                  <p className="text-gray-600 italic text-[15px] leading-relaxed" data-id="element-285">
                    "Este material me dio la confianza para armar tableros
                    completos desde cero."
                  </p>
                </div>
              </div>
            </LazySection>

            {/* Instagram Testimonials Carousel */}
            <LazySection delay={150} data-id="element-286">
              <div className="mt-8 mb-10 w-full max-w-md mx-auto px-2" data-id="element-287">
                <h3 className="text-center text-[18px] md:text-[20px] font-bold text-gray-900 mb-5" data-id="element-288">
                  Lo que dicen nuestros clientes en Instagram 💬
                </h3>
                <div className="relative" data-id="element-289">
                  <div className="flex overflow-x-auto snap-x snap-mandatory hide-scrollbar gap-4 pb-4" data-id="element-290">
                    {['https://cdn.magicpatterns.com/uploads/7TyF6VRSGD6KvuQZUcdpKg/sDRw8GV.png', 'https://cdn.magicpatterns.com/uploads/iGuWvtqvGfLYh172NVXqdK/dZS7I5f.png', 'https://cdn.magicpatterns.com/uploads/mL9WCTdvyhgNCYL7b9wgcw/lU1G7Yi.png'].map((src, index) => <div key={index} className="flex-shrink-0 w-[85%] sm:w-[90%] snap-center" data-id="element-291">
                        <img src={src} alt={`Testimonio Instagram ${index + 1}`} className="w-full h-auto rounded-2xl shadow-[0_4px_16px_rgba(0,0,0,0.08)] border border-gray-100" loading="lazy" data-id="element-292" />
                      </div>)}
                  </div>
                  {/* Fade edges for scroll indication */}
                  <div className="absolute top-0 bottom-4 left-0 w-4 bg-gradient-to-r from-[#FFFBEB] to-transparent pointer-events-none" data-id="element-293"></div>
                  <div className="absolute top-0 bottom-4 right-0 w-4 bg-gradient-to-l from-[#FFFBEB] to-transparent pointer-events-none" data-id="element-294"></div>
                </div>
              </div>
            </LazySection>

            {/* Antes y Después Section */}
            <LazySection delay={100} data-id="element-295">
              <div className="mt-12 mb-12 w-full max-w-4xl mx-auto px-2 md:px-4" data-id="element-296">
                <h2 className="text-center text-[22px] md:text-[32px] font-bold text-gray-900 mb-8 leading-tight font-[Poppins,_sans-serif]" data-id="element-297">
                  La diferencia entre seguir dudando… o empezar a ganar más con
                  lo que sabes
                </h2>

                <div className="grid md:grid-cols-2 gap-6" data-id="element-298">
                  {/* ANTES Card */}
                  <div className="bg-[#FFF5F5] border border-[#FEE2E2] rounded-2xl p-6 md:p-8" data-id="element-299">
                    <div className="flex items-center gap-2 mb-6" data-id="element-300">
                      <XCircle className="w-6 h-6 text-red-500" data-id="element-301" />
                      <h3 className="text-red-500 font-bold text-xl tracking-wide" data-id="element-302">
                        ANTES
                      </h3>
                    </div>
                    <ul className="space-y-4" data-id="element-303">
                      {['No entiendes lo que estás viendo', 'Dudas antes de aceptar trabajos', 'Otros avanzan más rápido que tú', 'Sigues cobrando menos de lo que podrías'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-304">
                          <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-305" />
                          <span className="text-gray-800 font-medium" data-id="element-306">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                  </div>

                  {/* DESPUÉS Card */}
                  <div className="bg-[#F0FDF4] border border-[#DCFCE7] rounded-2xl p-6 md:p-8 relative" data-id="element-307">
                    <div className="absolute -top-3 right-6 bg-[#22C55E] text-white text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-308">
                      TU FUTURO
                    </div>
                    <div className="flex items-center gap-2 mb-6" data-id="element-309">
                      <CheckCircle2 className="w-6 h-6 text-green-600" data-id="element-310" />
                      <h3 className="text-green-600 font-bold text-xl tracking-wide" data-id="element-311">
                        DESPUÉS
                      </h3>
                    </div>
                    <ul className="space-y-4" data-id="element-312">
                      {['Ves todo con claridad desde el primer momento', 'Trabajas con seguridad, no con miedo', 'Cometes menos errores y ganas más confianza', 'Puedes cobrar mejor por tu trabajo'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-313">
                          <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-314" />
                          <span className="text-gray-800 font-medium" data-id="element-315">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* Identification Heading */}
            <h2 className="text-center md:text-[32px] font-bold text-gray-900 mb-8 font-[Poppins,_sans-serif] text-[16px]" data-id="element-316">
              Este sistema es para ti si : estás cansado de dudar y quieres
              empezar a hacerlo bien desde el primer intento
            </h2>

            {/* Identification Card */}
            <LazySection delay={100} data-id="element-317">
              <div id="pain-section" className="bg-[#FBF8F1] rounded-[14px] shadow-[0_2px_16px_rgba(0,0,0,0.06)] p-7 md:p-10 mb-10 border border-[#F0EBE0] text-[18px]" data-id="element-318">
                <div className="space-y-5 max-w-lg mx-auto" data-id="element-319">
                  {['Tienes dificultades para leer e interpretar diagramas eléctricos convencionales.', 'Eres principiante y quieres aprender sobre controles eléctricos.', 'Estás cansado de perder servicios por no conocer los controles eléctricos.', 'Siempre necesitas contactar a otros electricistas con más experiencia para solucionar problemas.', 'Quieres aumentar tus ganancias.'].map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-320">
                      <CheckCircle2 className="w-5 h-5 text-[#7BAE7F] flex-shrink-0 mt-0.5" data-id="element-321" />
                      <p className="text-gray-800 md:text-[16px] text-[16px]" data-id="element-322">
                        {item}
                      </p>
                    </div>)}
                </div>
              </div>
            </LazySection>

            <LazySection delay={150} data-id="element-323">
              <FrustrationMethodSection data-id="element-324" />
            </LazySection>
          </div>
        </section>
      </LazySection>

      {/* Image Carousel - reinforces "Esta guía es para ti" */}
      <LazySection data-id="element-325">
        <div className="pt-6 md:pt-10 bg-white/80" data-id="element-326">
          <h2 className="md:text-4xl font-black text-gray-900 uppercase tracking-tight text-center px-4 mb-6 md:mb-8 text-[16px]" data-id="element-327">
            Consigue un total de 370 páginas a todo color con ilustraciones
            realistas
          </h2>
          <ImageCarousel data-id="element-328" />
        </div>
      </LazySection>

      {/* HERO SECTION */}
      <LazySection data-id="element-329">
        <section className="px-4 bg-[#FFFBEB] py-2 mt-[8px] mb-0" data-id="element-330">
          <div className="max-w-2xl mx-auto" data-id="element-331">
            <div className="flex justify-center mt-2" data-id="element-332">
              <img src="https://cdn.magicpatterns.com/uploads/1Ma4sTrAHUAYdaEPN8LkAw/30-day-money-back-guarantee-260nw-2631258675.webp" alt="Garantía de devolución de dinero - 7, 10, 15 y 30 días" className="max-w-[200px] w-full opacity-70" loading="lazy" style={{
              mixBlendMode: 'multiply'
            }} data-id="element-333" />
            </div>
            {/* GIF */}
            <div className="flex justify-center mt-4" data-id="element-334">
              <img src="https://cdn.magicpatterns.com/uploads/vWTbJmq8bdUR5XPWmFv9yJ/FKNwrJ8.gif" alt="Reacción de satisfacción" className="w-full max-w-sm md:max-w-md rounded-2xl shadow-lg" loading="lazy" decoding="async" data-id="element-335" />
            </div>
          </div>
        </section>
      </LazySection>

      {/* BONUSES SECTION */}
      <LazySection data-id="element-336">
        <section className="py-12 md:py-16 px-4 bg-[#0F1827]" data-id="element-337">
          <div className="max-w-4xl mx-auto" data-id="element-338">
            {/* Micro-urgency */}
            <p className="text-center text-[#FBBF24]/70 text-xs font-medium tracking-widest uppercase mb-6" data-id="element-339">
              ⏳ Acceso completo disponible por tiempo limitado
            </p>

            {/* Headline */}
            <h2 className="text-center text-[22px] md:text-[32px] font-black text-white mb-3 leading-tight font-[Poppins,_sans-serif]" data-id="element-340">
              Esto es lo que separa a los que siguen improvisando…{' '}
              <span className="text-[#4ADE80]" data-id="element-341">
                de los que empiezan a trabajar como verdaderos profesionales
              </span>
            </h2>
            <p className="text-center text-gray-400 text-sm md:text-base mb-10 max-w-xl mx-auto" data-id="element-342">
              La mayoría falla no por falta de ganas… sino por no tener las
              herramientas correctas.
            </p>

            {/* Bonus Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 max-w-lg md:max-w-4xl mx-auto" data-id="element-343">
              {/* BONO 01 */}
              <LazySection delay={100} data-id="element-344">
                <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 flex flex-col" data-id="element-345">
                  <img src="https://cdn.magicpatterns.com/uploads/aspoXaUZexU4VdVtU4U6GF/vNSeg6K.png" alt="Simulador Profesional - Lección en vídeo incluida" className="w-full max-w-[320px] mx-auto mb-4 rounded-lg" loading="lazy" data-id="element-346" />
                  <span className="text-[#4F6BFF] font-black text-xs tracking-widest uppercase mb-2" data-id="element-347">
                    🚀 BONO 01
                  </span>
                  <h3 className="text-white font-bold text-lg md:text-xl mb-3 leading-snug" data-id="element-348">
                    Simulador Profesional + Casos Reales + Clase Paso a Paso
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2 flex-grow" data-id="element-349">
                    Practica con más de 100 escenarios reales antes de
                    enfrentarte a un trabajo de verdad.
                  </p>
                  <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-4" data-id="element-350">
                    Muchos recuperan la inversión solo con aplicar esto una vez.
                  </p>
                  <div className="space-y-1.5 mb-5" data-id="element-351">
                    <p className="text-gray-300 text-sm" data-id="element-352">👉 Deja de adivinar</p>
                    <p className="text-gray-300 text-sm" data-id="element-353">👉 Llega preparado</p>
                    <p className="text-gray-300 text-sm" data-id="element-354">
                      👉 Evita errores costosos
                    </p>
                  </div>
                  <div className="border-t border-[#2A3444] pt-4 flex items-center justify-between" data-id="element-355">
                    <span className="text-gray-500 line-through text-sm" data-id="element-356">
                      De {loading ? '...' : formatPrice(97)}
                    </span>
                    <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-357">
                      Incluido hoy sin costo adicional
                    </span>
                  </div>
                </div>
              </LazySection>

              {/* BONO 02 */}
              <LazySection delay={200} data-id="element-358">
                <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 flex flex-col" data-id="element-359">
                  <img src="https://cdn.magicpatterns.com/uploads/nphXyDndjQ8swuhkaKbZ1P/bsQpJfQ.png" alt="Tabla de Presupuesto - ¿Qué cantidad cobrar?" className="w-full max-w-[320px] mx-auto mb-4 rounded-lg" loading="lazy" data-id="element-360" />
                  <span className="text-[#FBBF24] font-black text-xs tracking-widest uppercase mb-2" data-id="element-361">
                    ⚡ BONO 02
                  </span>
                  <h3 className="text-white font-bold text-lg md:text-xl mb-3 leading-snug" data-id="element-362">
                    Sistema de Presupuestos Listo para Usar
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2 flex-grow" data-id="element-363">
                    Deja de perder dinero por no saber cuánto cobrar.
                  </p>
                  <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-4" data-id="element-364">
                    Esto por sí solo ya vale más que todo el acceso.
                  </p>
                  <div className="space-y-1.5 mb-5" data-id="element-365">
                    <p className="text-gray-300 text-sm" data-id="element-366">👉 Calcula rápido</p>
                    <p className="text-gray-300 text-sm" data-id="element-367">
                      👉 Cobra con seguridad
                    </p>
                    <p className="text-gray-300 text-sm" data-id="element-368">
                      👉 Deja de trabajar por menos
                    </p>
                  </div>
                  <div className="border-t border-[#2A3444] pt-4 flex items-center justify-between" data-id="element-369">
                    <span className="text-gray-500 line-through text-sm" data-id="element-370">
                      De {loading ? '...' : formatPrice(57)}
                    </span>
                    <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-371">
                      Incluido hoy sin costo adicional
                    </span>
                  </div>
                </div>
              </LazySection>

              {/* BONO 03 */}
              <LazySection delay={300} data-id="element-372">
                <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 flex flex-col" data-id="element-373">
                  <img src="https://cdn.magicpatterns.com/uploads/oP4fTp1bFbZrWb6rCaUGkS/YenQaCW.png" alt="Dimensionamiento y Cotización de Motores Eléctricos" className="w-full max-w-[320px] mx-auto mb-4 rounded-lg" loading="lazy" data-id="element-374" />
                  <span className="text-[#F97316] font-black text-xs tracking-widest uppercase mb-2" data-id="element-375">
                    🔧 BONO 03
                  </span>
                  <h3 className="text-white font-bold text-lg md:text-xl mb-3 leading-snug" data-id="element-376">
                    Calculadora Profesional para Motores
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2 flex-grow" data-id="element-377">
                    Reduce errores y ejecuta con precisión sin depender de
                    nadie.
                  </p>
                  <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-4" data-id="element-378">
                    Es lo que evita errores que cuestan dinero real.
                  </p>
                  <div className="space-y-1.5 mb-5" data-id="element-379">
                    <p className="text-gray-300 text-sm" data-id="element-380">👉 Menos errores</p>
                    <p className="text-gray-300 text-sm" data-id="element-381">👉 Más confianza</p>
                    <p className="text-gray-300 text-sm" data-id="element-382">
                      👉 Más trabajos bien hechos
                    </p>
                  </div>
                  <div className="border-t border-[#2A3444] pt-4 flex items-center justify-between" data-id="element-383">
                    <span className="text-gray-500 line-through text-sm" data-id="element-384">
                      De {loading ? '...' : formatPrice(47)}
                    </span>
                    <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-385">
                      Incluido hoy sin costo adicional
                    </span>
                  </div>
                </div>
              </LazySection>

              {/* BONO 04 */}
              <LazySection delay={400} data-id="element-386">
                <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 flex flex-col" data-id="element-387">
                  <img src="https://cdn.magicpatterns.com/uploads/cMoeunLQ4mkQin17P2Eiax/ZmXOQ4S.png" alt="Plantilla - Informe Mensual de Ingresos Brutos" className="w-full max-w-[320px] mx-auto mb-4 rounded-lg" loading="lazy" data-id="element-388" />
                  <span className="text-[#A78BFA] font-black text-xs tracking-widest uppercase mb-2" data-id="element-389">
                    💰 BONO 04
                  </span>
                  <h3 className="text-white font-bold text-lg md:text-xl mb-3 leading-snug" data-id="element-390">
                    Plantilla para Controlar tus Ingresos
                  </h3>
                  <p className="text-gray-400 text-sm leading-relaxed mb-2 flex-grow" data-id="element-391">
                    Empieza a ver cuánto estás generando realmente y deja de
                    trabajar a ciegas.
                  </p>
                  <p className="text-[#4ADE80]/80 text-xs font-semibold italic mb-4" data-id="element-392">
                    Aquí es donde la mayoría deja de improvisar.
                  </p>
                  <div className="space-y-1.5 mb-5" data-id="element-393">
                    <p className="text-gray-300 text-sm" data-id="element-394">👉 Control total</p>
                    <p className="text-gray-300 text-sm" data-id="element-395">
                      👉 Decisiones más inteligentes
                    </p>
                    <p className="text-gray-300 text-sm" data-id="element-396">👉 Más crecimiento</p>
                  </div>
                  <div className="border-t border-[#2A3444] pt-4 flex items-center justify-between" data-id="element-397">
                    <span className="text-gray-500 line-through text-sm" data-id="element-398">
                      De {loading ? '...' : formatPrice(37)}
                    </span>
                    <span className="text-[#4ADE80] font-bold text-sm tracking-wide" data-id="element-399">
                      Incluido hoy sin costo adicional
                    </span>
                  </div>
                </div>
              </LazySection>
            </div>

            {/* Total Value */}
            <LazySection delay={200} data-id="element-400">
              <div className="mt-8 text-center" data-id="element-401">
                <p className="text-white text-2xl md:text-3xl font-black" data-id="element-402">
                  Valor real de estos recursos:{' '}
                  <span className="text-[#FBBF24] text-[32px]" data-id="element-403">
                    +{loading ? '...' : formatPrice(238)}
                  </span>
                </p>
                <p className="text-gray-400 text-sm mt-1" data-id="element-404">
                  Hoy los recibes incluidos al acceder
                </p>
              </div>
            </LazySection>

            {/* Closing Block */}
            <LazySection delay={250} data-id="element-405">
              <div className="mt-10 text-center max-w-xl mx-auto" data-id="element-406">
                <p className="text-white md:text-lg font-bold mb-6 text-[14px]" data-id="element-407">
                  Deja de dudar… empieza a trabajar con seguridad
                </p>

                {/* CTA */}
                <button onClick={() => {
                window.open('https://recetariosaludable.lat/cart/42439418740821:1', '_blank');
              }} className="green-cta-impact w-full max-w-md mx-auto text-white font-black md:text-xl py-5 px-8 rounded-2xl cursor-pointer bg-[#22C55E] font-[Roboto,_sans-serif] pt-[12px] pb-[12px] text-[20px]" data-id="element-408">
                  ¡Si! Quiero Mejorar mi Carrera{' '}
                  {loading ? '...' : formatPrice(19.99)}
                </button>
                <p className="text-gray-500 text-xs mt-3 tracking-wide" data-id="element-409">
                  Acceso inmediato • Sin complicaciones • Todo en un solo lugar
                </p>
              </div>
            </LazySection>

            {/* BONO ESPECIAL - Certificado Profesional */}
            <LazySection delay={150} data-id="element-410">
              <div className="mt-12 bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 md:p-10 max-w-4xl mx-auto" data-id="element-411">
                <div className="flex flex-col md:flex-row gap-6 md:gap-10 items-center" data-id="element-412">
                  {/* Certificate Image */}
                  <div className="w-full md:w-1/2 flex-shrink-0" data-id="element-413">
                    <img src="https://cdn.magicpatterns.com/uploads/oWKMnxjuZgANUEU6mSNrie/img-diploma-instalador-electricista-768x543-1.png.webp" alt="Certificado Profesional Reconocido - Comandos Eléctricos" className="w-full rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.2)]" loading="lazy" data-id="element-414" />
                  </div>

                  {/* Certificate Info */}
                  <div className="w-full md:w-1/2" data-id="element-415">
                    <span className="inline-block bg-[#22C55E] text-white text-xs font-bold px-4 py-1.5 rounded-full uppercase tracking-wider mb-4" data-id="element-416">
                      BONO ESPECIAL
                    </span>
                    <h3 className="text-white text-2xl md:text-3xl font-bold leading-tight mb-4" data-id="element-417">
                      Certificado Profesional Reconocido
                    </h3>
                    <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-6" data-id="element-418">
                      Al completar la guía, recibirás un certificado digital
                      emitido por una empresa reconocida en el sector eléctrico.
                      Úsalo para demostrar tu conocimiento, destacar frente a
                      otros técnicos y generar más confianza con tus clientes.
                    </p>
                    <div className="flex items-center gap-2.5" data-id="element-419">
                      <svg className="w-5 h-5 text-[#22C55E] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-420">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-421" />
                      </svg>
                      <span className="text-white font-bold text-sm md:text-base" data-id="element-422">
                        Incluido Gratis con tu compra
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* TODO ESTO COSTARÍA POR SEPARADO */}
            <LazySection delay={200} data-id="element-423">
              <div className="mt-12 max-w-lg mx-auto" data-id="element-424">
                <div className="bg-[#FFFDF5] border border-[#F0EBE0] rounded-2xl p-8 md:p-12 shadow-[0_4px_24px_rgba(0,0,0,0.06)]" data-id="element-425">
                  <h3 className="text-center text-lg md:text-xl font-black text-gray-800 uppercase tracking-wider mb-8" data-id="element-426">
                    TODO ESTO COSTARÍA POR SEPARADO:
                  </h3>
                  <div className="space-y-4" data-id="element-427">
                    {[{
                    name: 'Guía Práctica:',
                    price: 97
                  }, {
                    name: 'Simulador + Clase:',
                    price: 97
                  }, {
                    name: 'Tabla Presupuesto:',
                    price: 57
                  }, {
                    name: 'Hoja Motores:',
                    price: 47
                  }, {
                    name: 'Plantilla Ingresos:',
                    price: 37
                  }].map((item, i) => <div key={i} className="flex items-center justify-between border-b border-gray-200 pb-3" data-id="element-428">
                        <span className="text-gray-700 font-medium text-base" data-id="element-429">
                          {item.name}
                        </span>
                        <span className="text-gray-500 line-through text-base font-semibold" data-id="element-430">
                          {loading ? '...' : formatPrice(item.price)}
                        </span>
                      </div>)}
                  </div>
                  <div className="border-t-2 border-[#D9A441] mt-6 pt-6 text-center" data-id="element-431">
                    <p className="text-2xl md:text-3xl font-black text-gray-900" data-id="element-432">
                      Total:{' '}
                      <span className="text-red-500" data-id="element-433">
                        {loading ? '...' : formatPrice(238)}
                      </span>
                    </p>
                    <p className="text-[#22C55E] font-bold text-base md:text-lg mt-3" data-id="element-434">
                      ¡Hoy te lo llevas todo GRATIS con la guía!
                    </p>
                  </div>
                </div>
              </div>
            </LazySection>

            {/* BONO EXTRA EXCLUSIVO - Acceso Vitalicio */}
            <LazySection delay={250} data-id="element-435">
              <div className="mt-12 max-w-3xl mx-auto" data-id="element-436">
                <div className="bg-[#1A2332] border border-[#2A3444] rounded-2xl p-6 md:p-10" data-id="element-437">
                  <div className="flex flex-col md:flex-row gap-6 md:gap-8 items-center" data-id="element-438">
                    {/* Badge Image */}
                    <div className="w-32 md:w-40 flex-shrink-0" data-id="element-439">
                      <img src="https://cdn.magicpatterns.com/uploads/mpoG7HvQk8hYGhyZmup2hr/EbrESMe.png" alt="Acceso de por vida - Toda la vida" className="w-full drop-shadow-[0_4px_20px_rgba(217,164,65,0.4)]" loading="lazy" data-id="element-440" />
                    </div>

                    {/* Info */}
                    <div className="flex-1" data-id="element-441">
                      <p className="text-[#FBBF24] font-bold text-sm tracking-wider uppercase mb-2" data-id="element-442">
                        🎁 BONO EXTRA EXCLUSIVO
                      </p>
                      <h3 className="text-white text-2xl md:text-3xl font-black leading-tight mb-4" data-id="element-443">
                        Acceso Vitalicio
                      </h3>
                      <p className="text-gray-300 text-sm md:text-base leading-relaxed mb-5" data-id="element-444">
                        Olvídate de las mensualidades. Con un solo pago,
                        garantizas{' '}
                        <span className="text-white font-bold" data-id="element-445">
                          acceso de por vida
                        </span>{' '}
                        a todo el material y futuras actualizaciones sin pagar
                        un centavo más.
                      </p>
                      <div className="inline-flex items-center gap-2 bg-[#22C55E]/15 border border-[#22C55E]/30 rounded-full px-4 py-2" data-id="element-446">
                        <svg className="w-4 h-4 text-[#22C55E] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-447">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-448" />
                        </svg>
                        <span className="text-[#22C55E] font-bold text-sm uppercase tracking-wider" data-id="element-449">
                          INCLUIDO GRATIS
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </LazySection>
          </div>
        </section>
      </LazySection>

      {/* OFERTA PROMOCIONAL DE LANZAMIENTO */}
      <LazySection data-id="element-450">
        <section className="py-0 px-0 bg-[#0F1827]" data-id="element-451">
          {/* Blue Separator Banner */}
          <div className="bg-gradient-to-b from-[#1a3a6b] to-[#0d2b5e] py-10 px-4 text-center pt-[12px] pb-[12px]" data-id="element-452">
            {/* Stars */}
            <div className="flex justify-center gap-1 mb-4" data-id="element-453">
              {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="w-9 h-9 fill-[#FBBF24] text-[#FBBF24] drop-shadow-[0_2px_4px_rgba(251,191,36,0.4)]" data-id="element-454" />)}
            </div>

            {/* Heading */}
            <h2 className="text-center md:text-[32px] uppercase tracking-wide font-[Poppins,_sans-serif] text-white font-[800] max-w-lg mx-auto text-[20px]" data-id="element-455">
              OFERTA PROMOCIONAL DE LANZAMIENTO
            </h2>
          </div>

          {/* Product Card */}
          <div className="max-w-lg mx-auto px-4 py-10 md:py-14" data-id="element-456">
            <div className="border border-[#2A3444] rounded-2xl p-8 md:p-12 shadow-[0_8px_40px_rgba(0,0,0,0.2)] bg-[#F7F6F6]" data-id="element-457">
              {/* Product Mockup Collage */}
              <div className="relative w-full mb-10" data-id="element-458">
                {/* Main product centered */}
                <div className="relative mx-auto w-full max-w-sm" data-id="element-459">
                  <img src="https://cdn.magicpatterns.com/uploads/gpQcdGR9pb7tp62jigKpwF/8PXa8N2.png" alt="Sistema completo de Comandos Eléctricos - Todos los bonos incluidos" className="w-full rounded-xl shadow-[0_8px_30px_rgba(0,0,0,0.3)]" loading="lazy" data-id="element-460" />
                </div>
                {/* Floating bonus thumbnails */}
                <div className="flex justify-center gap-3 mt-5 flex-wrap" data-id="element-461">
                  <img src="https://cdn.magicpatterns.com/uploads/aspoXaUZexU4VdVtU4U6GF/vNSeg6K.png" alt="Bono Simulador" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover shadow-lg border-2 border-[#2A3444]" loading="lazy" data-id="element-462" />
                  <img src="https://cdn.magicpatterns.com/uploads/nphXyDndjQ8swuhkaKbZ1P/bsQpJfQ.png" alt="Bono Presupuesto" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover shadow-lg border-2 border-[#2A3444]" loading="lazy" data-id="element-463" />
                  <img src="https://cdn.magicpatterns.com/uploads/oP4fTp1bFbZrWb6rCaUGkS/YenQaCW.png" alt="Bono Motores" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover shadow-lg border-2 border-[#2A3444]" loading="lazy" data-id="element-464" />
                  <img src="https://cdn.magicpatterns.com/uploads/cMoeunLQ4mkQin17P2Eiax/ZmXOQ4S.png" alt="Bono Ingresos" className="w-16 h-16 md:w-20 md:h-20 rounded-lg object-cover shadow-lg border-2 border-[#2A3444]" loading="lazy" data-id="element-465" />
                </div>
              </div>

              {/* Checklist */}
              <div className="space-y-3 mb-8" data-id="element-466">
                {['Guía completa de más de 370 páginas con ilustraciones a color', 'Simulador y más de 100 diagramas para practicar + Clase', 'Explicaciones claras de dispositivos, motores y arrancadores', 'Lista de materiales y estrategias para presupuestar', 'Certificado profesional de una empresa reconocida', 'Aprende a interpretar esquemas reales', 'Plantilla de control de ingresos incluida', 'Acceso vitalicio sin pagos recurrentes'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-467">
                    <svg className="w-5 h-5 text-[#22C55E] flex-shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-468">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" data-id="element-469" />
                    </svg>
                    <span className="text-sm md:text-base text-[#0D0E0E] font-[700] font-[Poppins,_sans-serif]" data-id="element-470">
                      {item}
                    </span>
                  </div>)}
              </div>

              {/* Pricing Box */}
              <div className="flex flex-col items-center mb-8" data-id="element-471">
                <p className="text-gray-500 text-base font-medium mb-1" data-id="element-472">
                  Precio Regular por Todo:
                </p>
                <p className="text-gray-400 text-2xl font-bold line-through mb-4" data-id="element-473">
                  {loading ? '...' : formatPrice(97)}
                </p>

                <div className="w-full bg-white border-2 border-[#E5E7EB] rounded-xl p-6 text-center shadow-[0_4px_20px_rgba(0,0,0,0.06)]" data-id="element-474">
                  <p className="md:text-xl font-extrabold mb-1 text-[18px] text-[#464242]" data-id="element-475">
                    Precio Especial HOY de Lanzamiento:
                  </p>
                  <p className="md:text-[64px] font-black text-gray-900 mt-2 mb-3 text-[40px]" data-id="element-476">
                    {loading ? '...' : formatPrice(19.99)}
                  </p>
                  {!loading && currency && currency.code !== 'USD' && <div className="inline-flex items-center gap-2 bg-gray-100 rounded-full px-4 py-1.5 mt-1" data-id="element-477">
                      <span className="text-sm text-gray-600" data-id="element-478">
                        En tu moneda local
                      </span>
                      <span className="text-sm font-bold text-gray-800" data-id="element-479">
                        {currency.flag} {currency.code}{' '}
                        {(19.99 * currency.rate).toLocaleString(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                      </span>
                    </div>}
                </div>
              </div>

              {/* Urgency Text */}
              <p className="text-center text-red-500 font-bold md:text-base tracking-wide mb-6 uppercase text-[12px]" data-id="element-480">
                APROVECHA AHORA: NO ENCONTRARÁS ESTE PRECIO MÁS ADELANTE.
              </p>

              {/* CTA */}
              <button onClick={() => {
              window.open('https://recetariosaludable.lat/cart/42439418740821:1', '_blank');
            }} className="green-cta-impact w-full text-white md:text-xl py-4 px-8 rounded-2xl cursor-pointer pt-[12px] pb-[12px] bg-[#22C55F] font-[900] font-[Inter,_sans-serif] text-[20px]" data-id="element-481">
                ¡Si! Quiero Mejorar mi Carrera
              </button>
              <p className="text-gray-500 text-xs mt-3 tracking-wide text-center" data-id="element-482">
                Acceso inmediato • Sin pagos mensuales • Empiezas en segundos
              </p>

              {/* Safe Checkout Badges */}
              <div className="mt-4 flex justify-center" data-id="element-483">
                <img src="https://cdn.magicpatterns.com/uploads/p6qxTwGmZgbzY9XkZUWTq8/Trust-badges.webp" alt="Guaranteed Safe Checkout - AES-256bit, PayPal, Stripe, McAfee Secure, Norton Secured, Visa, MasterCard, American Express, Discover" className="max-w-[320px] w-full" loading="lazy" data-id="element-484" />
              </div>
            </div>
          </div>
        </section>
      </LazySection>

      {/* GUARANTEE BADGE */}
      <LazySection data-id="element-485">
        <section className="py-12 px-4 bg-[#FFFBEB]" data-id="element-486">
          <div className="max-w-lg mx-auto" data-id="element-487">
            <div className="bg-white rounded-2xl shadow-[0_2px_20px_rgba(0,0,0,0.06)] border border-[#F0EBE0] p-8 md:p-10 text-center" data-id="element-488">
              {/* Badge Circle */}
              <div className="mx-auto mb-6 w-28 h-28 rounded-full bg-gradient-to-b from-[#F7D060] to-[#D9A441] flex flex-col items-center justify-center shadow-[0_4px_16px_rgba(217,164,65,0.3)] border-4 border-[#C8A84E]" data-id="element-489">
                <span className="text-[36px] font-black text-gray-900 leading-none" data-id="element-490">
                  30
                </span>
                <span className="text-[11px] font-bold text-gray-800 uppercase tracking-wider" data-id="element-491">
                  Días
                </span>
                <span className="bg-gray-900 text-[#F7D060] text-[9px] font-black px-3 py-0.5 rounded-sm uppercase tracking-widest mt-0.5" data-id="element-492">
                  Garantía
                </span>
              </div>

              {/* Title */}
              <h3 className="md:text-2xl font-black text-gray-900 mb-4 text-[24px] font-[Inter,_sans-serif]" data-id="element-493">
                Pruebalo durante 30 dias
              </h3>

              {/* Description */}
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-2" data-id="element-494">
                No quiero tu dinero si este manual no transforma tu cocina. Por
                eso te doy mi{' '}
                <span className="font-bold text-gray-900" data-id="element-495">
                  Garantía Blindada de 30 Días
                </span>
                .
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5" data-id="element-496">
                Si sentís que no es para vos, nos enviás un correo y te
                devolvemos el{' '}
                <span className="font-bold text-gray-900" data-id="element-497">
                  100% de tu inversión
                </span>
                . Sin preguntas, sin vueltas.
              </p>

              {/* Closing line */}
              <p className="text-[#D9A441] font-bold text-sm md:text-base italic" data-id="element-498">
                — El riesgo es todo nuestro.
              </p>
            </div>
          </div>
        </section>
      </LazySection>

      <LazySection data-id="element-499">
        <AboutAuthorSection data-id="element-500" />
      </LazySection>

      <LazySection data-id="element-501">
        <FAQSection data-id="element-502" />
      </LazySection>

      {/* URGENCY & FINAL CLOSE */}
      <LazySection data-id="element-503">
        <div className="py-10 px-4 bg-[#0F1827] text-center" data-id="element-504">
          <div className="max-w-md mx-auto" data-id="element-505">
            <p className="text-white md:text-lg font-bold mb-4 text-[14px]" data-id="element-506">
              No dejes pasar esta oportunidad
            </p>
            <button onClick={() => {
            window.open('https://recetariosaludable.lat/cart/42439418740821:1', '_blank');
          }} className="green-cta-impact w-full text-white md:text-xl py-4 px-8 rounded-2xl cursor-pointer pt-[12px] pb-[12px] bg-[#22C55F] text-[20px] font-[900] font-[Inter,_sans-serif]" data-id="element-507">
              ¡Si! Quiero Mejorar mi Carrera
            </button>
            <p className="text-gray-500 text-xs mt-3 tracking-wide" data-id="element-508">
              Acceso inmediato • Sin pagos mensuales • Empiezas en segundos
            </p>
          </div>
        </div>
      </LazySection>

      {/* Footer */}
      <LazySection data-id="element-509">
        <footer className="bg-[#0F1827] py-8 px-4 text-center" data-id="element-510">
          <p className="text-gray-400 text-sm" data-id="element-511">
            📧 Contacto:{' '}
            <a href="mailto:apoyocomunidadelectrica@gmail.com" className="text-[#F7D060] hover:underline font-medium" data-id="element-512">
              apoyocomunidadelectrica@gmail.com
            </a>
          </p>
          <p className="text-gray-500 text-xs mt-3" data-id="element-513">
            © {new Date().getFullYear()} Comunidad Eléctrica. Todos los
            derechos reservados.
          </p>
        </footer>
      </LazySection>

      {/* Bottom spacer for floating CTA */}
      <div className="h-20" data-id="element-514" />
    </div>;
}